module.exports = __webpack_public_path__ + "static/images/index-default-big.a406571.png";